import { NameDisplayPreference } from "./nameDisplayPreference.modal";


export class NameSettingDTO {

    profileId: number;
    publicName: string;
    nameDisplayPreference: NameDisplayPreference;


    constructor() {
        this.profileId = 0;
        this.publicName = '';
        this.nameDisplayPreference = new NameDisplayPreference();
    }
}